import {
  FETCH_OPERATIONS_PAST_DUE_PERIODS_FAILURE,
  FETCH_OPERATIONS_PAST_DUE_PERIODS_REQUEST,
  FETCH_OPERATIONS_PAST_DUE_PERIODS_SUCCESS
} from '../constants/operationsReportingToDo';
import { Actions, OperationsPastDuePeriod } from 'actions/operationsReportingToDo';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';

export type State = DeepReadonly<{
  isFetching: boolean;
  periods: OperationsPastDuePeriod[] | null;
  error: AxiosError | null;
}>;

const initialState: State = {
  isFetching: false,
  periods: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case FETCH_OPERATIONS_PAST_DUE_PERIODS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_OPERATIONS_PAST_DUE_PERIODS_SUCCESS:
      return {
        isFetching: false,
        periods: action.payload,
        error: null
      };
    case FETCH_OPERATIONS_PAST_DUE_PERIODS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
